
export default {
    configuration: true,
    'searchList': {
        'searchTxt': [
            {
                'name': '服务平台',
                'value': 'siteName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
                ],
                'advanceUrl': '/searchPlatform',
                'type': 'advance',
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                'span': 4
            },
            {
                'name': '状态',
                'value': 'algorithmStatus',
                'type': 'select',
                'options': [
                    { label: '启用', value: '0' },
                    { label: '停用', value: '1' }
                ],
                'unfold': true,
                'span': 3
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 160,
        'height': '400px',
        leftOperation: true,
        'columns': [
            {
                'label': '状态',
                'prop': 'algorithmStatusName',
                'width': 100,
                'sort': true
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'type': 'button',
                'width': 140,
                'sort': true
            },
            {
                'label': '串点集中度',
                'prop': 'inDistanceValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '加速参数(0~1)',
                'prop': 'accValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '最大串点数量',
                'prop': 'slackNValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '线路距离上限',
                'prop': 'slackDValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '线路最长用时',
                'prop': 'maxRouteTimeValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '每小时装卸点数',
                'prop': 'efValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '车辆的平均时速',
                'prop': 'aveSpeedValue',
                'width': 140,
                'sort': true
            },
            {
                'label': '修改人',
                'prop': 'updateUserName',
                'width': 100,
                'sort': true
            },
            {
                'label': '修改时间',
                'prop': 'updateTime',
                'width': 160,
                'sort': true
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'small',
                'event': 'edit',
                'ifHas': 'otp02050004'
            },
            {
                'type': 'text',
                'label': '启用',
                'size': 'small',
                'event': 'enable',
                'ifHas': 'otp02050005'
            },
            {
                'type': 'text',
                'label': '停用',
                'size': 'small',
                'event': 'disable',
                'ifHas': 'otp02050006'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [
            10,
            20,
            30,
            50
        ]
    }
};
